import type { dailyArticles } from '@/mocks/home';

interface DailyArticlesProps {
  articles: typeof dailyArticles;
}

export default function DailyArticles({ articles }: DailyArticlesProps) {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="text-xs font-medium text-primary-500 tracking-widest uppercase">
            每日精选
          </span>
          <h2 className="mt-3 text-3xl md:text-5xl font-heading font-black text-foreground-950">
            今日黑料速递
          </h2>
          <p className="mt-3 text-foreground-500 text-sm max-w-[500px] mx-auto">
            每日更新最新吃瓜爆料，网红塌房、明星私聊、综艺黑幕，一网打尽
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                {article.hot && (
                  <div className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium flex items-center gap-1">
                    <i className="ri-fire-line text-[10px]"></i>
                    热门
                  </div>
                )}
                <div className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-background-50/80 backdrop-blur-sm text-foreground-700 text-xs font-medium">
                  {article.category}
                </div>
              </div>
              <div className="p-4 md:p-5 flex-1 flex flex-col">
                <h3 className="text-foreground-900 text-base font-bold leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="mt-2 text-foreground-500 text-sm line-clamp-2 flex-1">{article.excerpt}</p>
                <div className="flex items-center justify-between mt-4 pt-3 border-t border-background-200">
                  <span className="text-foreground-400 text-xs">{article.date}</span>
                  <span className="text-foreground-400 text-xs flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link to="/category/heiliao-jinri"
            className="inline-flex items-center gap-2 bg-foreground-950 text-background-50 px-8 py-3 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            查看更多爆料
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}